import './functions';
import './logic';
import './variables';
import './virtuals';
import { wrapperBuilder } from './build';

export const InternationalizationWrapper = wrapperBuilder.build();
